import { empApi } from "./client";

// =============================================================
// API Phê duyệt nghỉ phép (quản lý) - FEv1 cổng nhân viên.
// Khớp endpoint app (backend-v1). Phạm vi duyệt do BE lọc theo token.
// =============================================================

// Danh sách theo khối kinh doanh (quản lý kinh doanh) -> { items, pagination }
export const getBusinessLeaveListApi = (params) =>
  empApi.get("/leaveRequest/app/businessManager", params);

// Danh sách theo khối hỗ trợ kinh doanh -> { items, pagination }
export const getSupportBusinessLeaveListApi = (params) =>
  empApi.get("/leaveRequest/app/supportBusinessManager", params);

// Chi tiết đơn (góc nhìn quản lý)
export const getManagerLeaveDetailApi = (id) =>
  empApi.get(`/leaveRequest/app/manager/${id}`);

// Duyệt (status=2) / từ chối (status=3)
export const approveLeaveApi = (id, status) =>
  empApi.put(`/leaveRequest/app/manager/approve/${id}`, { status });
